import { gql } from "@apollo/client";

export const TENDLC_FIELDS = gql`
  fragment TenDlcFields on TenDlcCampaign {
    tcrCampaignId
    tcrBrandId
    friendlyName
    status
    tpm
    mmsTpm
    brandTmobileCap
    mnoMetadataLastSynced
    numberLimit
    currentNumberCount
    error
    numbers {
      id
      phoneNumber
      displayName
      createdAt
      messageClass
      provider
      state
      provisioningState
      tenDlcCampaignId
      subaccounts {
        subaccountId
        state
        isPrimary
      }
      optInGroup {
        id
        name
        ownedPhoneNumbers {
          id
          subaccounts {
            subaccountId
            state
          }
        }
      }
    }
    retoolId
    createdAt
    provider
  }
`;

export const LIST_10DLC_CAMPAIGNS = gql`
  ${TENDLC_FIELDS}
  query getTenDlcCampaignsForSubaccount(
    $input: TenDlcCampaignsForSubaccountInput!
  ) {
    tenDlcCampaignsForSubaccount(input: $input) {
      ...TenDlcFields
    }
  }
`;

export const PURCHASE_10DLC_NUMBERS = gql`
  mutation purchaseTenDlcPhoneNumbers(
    $input: PurchaseTenDlcPhoneNumbersInput!
  ) {
    purchaseTenDlcPhoneNumbers(input: $input) {
      id
      phoneNumber
    }
  }
`;

export const RETOOL_CAMPAIGN_REGISTRATIONS = gql`
  query retoolTenDlcRegistrations($input: RetoolTenDlcRegistrationsInput!) {
    retoolTenDlcRegistrations(input: $input) {
      id
      tcrCampaignId
      description
      status
      error
      submittedAt
      subaccountId
    }
  }
`;

export const UPDATE_FRIENDLY_NAME = gql`
  ${TENDLC_FIELDS}
  mutation UpdateFriendlyName($input: UpdateFriendlyNameInput!) {
    updateFriendlyName(input: $input) {
      ...TenDlcFields
    }
  }
`;

export const UPDATE_NUMBER_LIMIT = gql`
  ${TENDLC_FIELDS}
  mutation UpdateNumberLimit($input: UpdateNumberLimitInput!) {
    updateNumberLimit(input: $input) {
      ...TenDlcFields
    }
  }
`;

export const MANUAL_SYNC_TCR_MNO_METADATA = gql`
  ${TENDLC_FIELDS}
  mutation ManualSyncTcrMnoMetadata($input: ManualSyncTcrMnoMetadataInput!) {
    manualSyncTcrMnoMetadata(input: $input) {
      ...TenDlcFields
    }
  }
`;

export const REMOVE_10DLC_CAMPAIGN_FROM_SUBACCOUNT = gql`
  mutation Remove10DlcCampaignFromSubaccount(
    $input: Remove10DlcCampaignFromSubaccountInput!
  ) {
    remove10DlcCampaignFromSubaccount(input: $input) {
      success
    }
  }
`;

export const DEACTIVATE_10DLC_CAMPAIGN = gql`
  mutation Deactivate10DlcCampaign($input: Deactivate10DlcCampaignInput!) {
    deactivate10DlcCampaign(input: $input)
  }
`;
